import { render, staticRenderFns } from "./lowThreshold-editor.vue?vue&type=template&id=d66e35d0&scoped=true&"
import script from "./lowThreshold-editor.vue?vue&type=script&lang=js&"
export * from "./lowThreshold-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66e35d0",
  null
  
)

export default component.exports